export default {"src":"/_next/static/media/anim.da361fa1.svg","height":28,"width":49,"blurWidth":0,"blurHeight":0};